var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atmosphere main"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"case"}),_c('img',{staticClass:"code code-an",attrs:{"src":"https://image.xiaoxxx.cn/test/urlGather/202407166b4e95c6411fea29113609.png","alt":""}})])])
}]

export { render, staticRenderFns }